export const getUserProfileData  = state => {
  return state.UserReducer.userProfileData;
}
export const selectAdmissionStatus = state => {
  return state.UserReducer.userDetails.admissionStatus;
};

export const getCustomerId = state => {
  return state.UserReducer.userDetails.customerId;
};

export const getUserId = state => {
  return state.UserReducer.userDetails.userId;
};
